import React from "react";
import { useTranslation } from "react-i18next";

import HomeStyles from "./Home.module.scss";

import TextAnimation from "../TextAnimation/TextAnimation";

import ScrollDown from "../ScrollDown/ScrollDown";

const Home = ({ scrollToAboutMe }) => {
  const { t } = useTranslation();

  return (
    <div className={HomeStyles.container}>
      <div className={HomeStyles.middle}>
        <div className={HomeStyles.homeText}>
          {t("home.developer")}
          <TextAnimation
            text={["Web Junior", "Full Stack", "JavaScript", "React", "NestJS"]}
          />
        </div>
      </div>
      <div className={HomeStyles.scroll}>
        <ScrollDown scrollDown={scrollToAboutMe} />
      </div>
    </div>
  );
};

export default Home;
